(function() {
  const section = document.querySelector('[data-ajax-filters]');
  if (!section) return;

  const filtersDrawer = document.getElementById('collection-filters-drawer');
  const filterToggle = section.querySelector('.collection-toolbar__filter-toggle');
  const closeButtons = section.querySelectorAll('[data-close-filters]');
  const filterForm = section.querySelector('[data-filter-form]');
  const sortSelect = section.querySelector('[data-sort-select]');

  /* Toggle filters drawer (mobile) — con focus trap (PL-1) */
  var releaseFiltersTrap = null;

  function closeFiltersDrawer() {
    if (!filtersDrawer) return;
    filtersDrawer.classList.remove('is-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (releaseFiltersTrap) {
      releaseFiltersTrap();
      releaseFiltersTrap = null;
    }
  }

  if (filterToggle && filtersDrawer) {
    filterToggle.addEventListener('click', function() {
      var isOpen = filtersDrawer.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
      if (isOpen && window.innerWidth < 1024 && window.ThemeUtils && ThemeUtils.trapFocus) {
        releaseFiltersTrap = ThemeUtils.trapFocus(filtersDrawer, { onEscape: closeFiltersDrawer });
      } else if (!isOpen && releaseFiltersTrap) {
        releaseFiltersTrap();
        releaseFiltersTrap = null;
      }
    });
  }

  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', closeFiltersDrawer);
  });

  /* Desktop: show filters by default */
  if (filtersDrawer && window.innerWidth >= 1024) {
    filtersDrawer.classList.add('is-open');
  }

  /* Sort change */
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      navigateTo(url.toString());
    });
  }

  /* Sort dropdown custom (proxy al select oculto → reusa el handler de arriba) */
  var sortWrap = section.querySelector('[data-collection-sort]');
  if (sortWrap && sortSelect) {
    var sortToggle = sortWrap.querySelector('[data-sort-toggle]');
    var sortMenu = sortWrap.querySelector('[data-sort-menu]');
    var sortLabel = sortWrap.querySelector('[data-sort-label]');

    sortToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var open = sortMenu.hidden;
      sortMenu.hidden = !open;
      sortToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    sortMenu.addEventListener('click', function(e) {
      var opt = e.target.closest('[data-value]');
      if (!opt) return;
      sortSelect.value = opt.getAttribute('data-value');
      sortLabel.textContent = opt.textContent.trim();
      sortMenu.querySelectorAll('[data-value]').forEach(function(o) {
        o.setAttribute('aria-selected', o === opt ? 'true' : 'false');
      });
      sortMenu.hidden = true;
      sortToggle.setAttribute('aria-expanded', 'false');
      sortSelect.dispatchEvent(new Event('change'));
    });

    document.addEventListener('click', function(e) {
      if (!sortWrap.contains(e.target)) {
        sortMenu.hidden = true;
        sortToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Filtros: aplican al marcar (AJAX), igual que en búsqueda. El botón
     "Ver resultados" del footer solo cierra el drawer (data-close-filters). */
  if (filterForm) {
    filterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      applyFilters();
    });

    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        applyFilters();
      });
    });

    /* Slider de precio (ThemeUtils.rangeSlider) sincronizado con los inputs
       nativos ocultos de Shopify. Dominio en centavos; los inputs van en
       unidades (pesos) que es lo que espera el filtro nativo. */
    var priceSliderEl = filterForm.querySelector('[data-collection-price-slider]');
    var priceMinInput = filterForm.querySelector('[data-price-min-input]');
    var priceMaxInput = filterForm.querySelector('[data-price-max-input]');

    function initPriceSlider(vMin, vMax) {
      if (!priceSliderEl || !window.ThemeUtils || !ThemeUtils.rangeSlider) return;
      var pMin = parseInt(priceSliderEl.dataset.min, 10) || 0;
      var pMax = parseInt(priceSliderEl.dataset.max, 10) || 0;
      if (!(pMax > pMin)) return;
      var moneyFmt = priceSliderEl.dataset.moneyFormat;
      ThemeUtils.rangeSlider(priceSliderEl, {
        min: pMin,
        max: pMax,
        valueMin: vMin !== undefined ? vMin : (priceSliderEl.dataset.valueMin || pMin),
        valueMax: vMax !== undefined ? vMax : (priceSliderEl.dataset.valueMax || pMax),
        format: function(v) { return ThemeUtils.formatMoney(v, moneyFmt); },
        parse: function(s) { var n = parseInt(String(s).replace(/[^\d]/g, ''), 10); return isNaN(n) ? null : n * 100; },
        labelMin: 'Precio mínimo',
        labelMax: 'Precio máximo',
        onCommit: function(lo, hi) {
          if (priceMinInput) priceMinInput.value = lo > pMin ? Math.round(lo / 100) : '';
          if (priceMaxInput) priceMaxInput.value = hi < pMax ? Math.round(hi / 100) : '';
          applyFilters();
        }
      });
    }
    initPriceSlider();

    /* Colapsar/expandir grupos (mismo patrón que búsqueda) */
    filterForm.addEventListener('click', function(e) {
      var label = e.target.closest('.facet-group__label');
      if (!label) return;
      label.closest('.facet-group').classList.toggle('is-collapsed');
    });

    /* Atajos por tipo: marcan el checkbox correspondiente del formulario de
       filtros y aplican, para no duplicar la lógica de filtrado. */
    /* Delegado en la sección, no en el contenedor de los chips: el AJAX
       reemplaza toda la columna de productos al filtrar, así que un listener
       puesto sobre los chips moriría en el primer clic. */
    section.addEventListener('click', function(e) {
      var mas = e.target.closest('[data-chips-more]');
      if (mas) {
        var wrap = mas.closest('[data-type-chips]');
        if (wrap) wrap.classList.add('is-expanded');
        return;
      }

      var chip = e.target.closest('[data-chip-name]');
      if (!chip) return;
      var cb = filterForm.querySelector(
        'input[name="' + chip.dataset.chipName + '"][value="' + chip.dataset.chipValue + '"]'
      );
      if (!cb) return;
      cb.checked = !cb.checked;
      applyFilters();
    });

    /* "+N más": revela el resto de opciones del grupo */
    filterForm.addEventListener('click', function(e) {
      var mas = e.target.closest('[data-facet-more]');
      if (!mas) return;
      e.preventDefault();
      var grupo = mas.closest('.facet-group');
      if (grupo) grupo.classList.add('is-expanded');
    });

    /* Limpiar filtros: desmarca todo, resetea el slider y aplica (URL limpia) */
    var clearBtn = filterForm.querySelector('[data-filters-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) { cb.checked = false; });
        if (priceMinInput) priceMinInput.value = '';
        if (priceMaxInput) priceMaxInput.value = '';
        initPriceSlider(parseInt(priceSliderEl && priceSliderEl.dataset.min, 10) || 0, parseInt(priceSliderEl && priceSliderEl.dataset.max, 10) || 0);
        applyFilters();
      });
    }
  }

  /* Por defecto: solo "en existencia". Si la URL no trae ningún filtro y existe
     el checkbox de disponibilidad, lo marcamos y aplicamos (AJAX). El usuario
     puede destildarlo en el drawer para ver los agotados. */
  (function defaultInStock() {
    var name = section.getAttribute('data-instock-name');
    var value = section.getAttribute('data-instock-value');
    if (!name || !filterForm) return;
    if (/[?&]filter\./.test(window.location.search)) return; // ya hay filtros activos
    var cb = filterForm.querySelector('input[name="' + name + '"][value="' + value + '"]');
    if (cb && !cb.checked) {
      cb.checked = true;
      applyFilters();
    }
  })();

  function applyFilters() {
    var formData = new FormData(filterForm);
    var url = new URL(window.location.href);

    /* Clear existing filter params */
    var keysToDelete = [];
    url.searchParams.forEach(function(val, key) {
      if (key.startsWith('filter.') || key === 'page') {
        keysToDelete.push(key);
      }
    });
    keysToDelete.forEach(function(key) { url.searchParams.delete(key); });

    /* Add new filter params */
    formData.forEach(function(value, key) {
      if (value !== '' && value !== null) {
        url.searchParams.append(key, value);
      }
    });

    navigateTo(url.toString());
  }

  function navigateTo(url) {
    var cur = document.getElementById('collection-products');
    if (cur) {
      cur.style.opacity = '0.5';
      cur.style.pointerEvents = 'none';
    }

    fetch(url)
      .then(function(response) { return response.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        /* Solo se recargan las cards (grid) + contador + chips. El toolbar,
           drawer y sort persisten → sus handlers siguen vivos, sin reinit ni
           flash de toda la sección. */
        var newProducts = doc.getElementById('collection-products');
        if (newProducts && cur) cur.innerHTML = newProducts.innerHTML;

        /* Contador */
        var newCount = doc.querySelector('.collection-toolbar__count');
        var curCount = section.querySelector('.collection-toolbar__count');
        if (newCount && curCount) curCount.textContent = newCount.textContent;

        /* Chips de filtros activos (pueden aparecer/desaparecer) */
        var newChips = doc.querySelector('.collection-active-filters');
        var curChips = section.querySelector('.collection-active-filters');
        if (newChips) {
          if (curChips) { curChips.replaceWith(newChips); }
          else {
            /* Los chips van entre la cabecera y la grilla (afterend de
               .search-head). Antes se insertaban tras .collection-toolbar, que
               ahora vive DENTRO de .search-head → quedaban mal anidados. */
            var head = section.querySelector('.search-head');
            if (head) head.insertAdjacentElement('afterend', newChips);
          }
        } else if (curChips) {
          curChips.remove();
        }

        /* Badge de nº de filtros en el botón Filtro */
        var newBadge = doc.querySelector('.search-toolbar__active-count');
        var btn = section.querySelector('.collection-toolbar__filter-toggle');
        var curBadge = btn ? btn.querySelector('.search-toolbar__active-count') : null;
        if (btn) {
          if (newBadge) {
            if (curBadge) curBadge.textContent = newBadge.textContent;
            else btn.insertAdjacentElement('beforeend', newBadge);
          } else if (curBadge) {
            curBadge.remove();
          }
        }

        if (cur) { cur.style.opacity = ''; cur.style.pointerEvents = ''; }

        /* Anunciar resultados (PL-2) + scroll al toolbar */
        if (curCount && window.ThemeUtils && ThemeUtils.announce) {
          ThemeUtils.announce(curCount.textContent.trim());
        }
        var top = section.getBoundingClientRect().top + window.scrollY - 80;
        if (window.scrollY > top) {
          window.scrollTo({ top: top, behavior: 'smooth' });
        }

        window.history.pushState({}, '', url);
      })
      .catch(function() {
        window.location.href = url;
      });
  }

  /* Handle browser back/forward */
  window.addEventListener('popstate', function() {
    window.location.reload();
  });

  /* Ya no hace falta reinit(): navigateTo solo reemplaza el grid + contador +
     chips, así que el toolbar/drawer/sort persisten con sus handlers intactos. */
})();
